<template>
  <div
    v-if="isPermittedAll([
      'SupportContractsGetAll',
    ])"
    class="support-contracts-form-table">
    <!-- Label / Actions -->
    <div class="d-flex align-end">
      <!-- Label -->
      <label class="line-height-1 mb-1">Support Contracts:</label>
      <!-- / Label -->

      <!-- Actions -->
      <div class="ml-auto mb-2 d-flex align-center">
        <!-- Include Hidden -->
        <v-checkbox
          v-if="isPermittedAll([
            'SupportContractsViewDeleted',
          ])"
          v-model="hiddenStatus"
          @change="getComputerSupportContracts"
          label="Include Hidden"
          class="mt-0 pt-0"
          true-value="ShowAny"
          false-value="ShowNotHidden"
          hide-details>
        </v-checkbox>
        <!-- / Include Hidden -->

        <!-- Add -->
        <v-btn
          v-if="isPermittedAll([
            'SupportContractsCreate',
          ])"
          class="square ml-3"
          title="Add Support Contract"
          type="button"
          color="primary"
          :disabled="$store.getters.isLoadingActive"
          @click="$store.dispatch(
              'openSupportContractModalForm',
              {
                supportContract: {
                  ComputerID: computerId,
                },
              },
            )"
          block>
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <!-- / Add -->
      </div>
      <!-- / Actions -->
    </div>
    <!-- / Label / Actions -->

    <!-- Table  -->
     <div style="overflow-y: auto" v-if="isMobile">
      <v-expansion-panels multiple v-model="expanded" class="custom-expansion">  
        <v-expansion-panel
          v-for="(contract, i) in mobileFilteredComputerSupportContracts"
        >
          <v-expansion-panel-header>
            <div  v-if="expanded.includes(i) === false">
             {{contract.SupportContractEndUtc | date}}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <div>
              <div>
                <b>Contract ID</b>
                <p>{{ contract.SupportContractID }}</p> 
              </div>
              <div>
                <b>Start Date</b>
                <p>{{contract.SupportContractStartUtc | date}}</p> 
              </div> 
              <div class="d-flex">
                <div>
                  <b>End Date</b>
                  <p>{{contract.SupportContractEndUtc | date}}</p> 
                </div>
                <v-btn
                 v-if="isPermittedAll([
                  'SupportContractsGetByID',
                  ])"
                  @click="$store.dispatch(
                    'openSupportContractModalForm',
                    {
                      supportContract: {
                        SupportContractID: contract.SupportContractID,
                      },
                    }
                  )"
                  type="button"
                  color="primary"
                  outlined
                  class="ml-auto align-self-center">
                  Edit
                </v-btn> 
              </div>
            </div>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>
    <v-data-table v-else
      class="form-table"
      :headers="supportContractFields"
      :items="computerSupportContracts"
      mobile-breakpoint="-1"
      item-key="SupportContractID"
      dense
      disable-pagination
      hide-default-footer
      fixed-header
      :options="{
        sortBy: ['SupportContractID'],
        rowsPerPage: -1,
      }">
      <template
        v-slot:item="row">
        <tr
          :class="{
            'hidden-table-row': row.item.SupportContractIsDeleted
          }">
          <td class="action-column">
            <v-btn
              v-if="isPermittedAll([
                'SupportContractsGetByID',
              ])"
              class="square plain"
              :disabled="$store.getters.isLoadingActive"
              @click="$store.dispatch(
                'openSupportContractModalForm',
                {
                  supportContract: {
                    SupportContractID: row.item.SupportContractID,
                  },
                }
              )">
              <v-icon size="16px">mdi-square-edit-outline</v-icon>
            </v-btn>
          </td>
          <td>{{row.item.SupportContractID}}</td>
          <td>{{row.item.SupportContractStartUtc | date}}</td>
          <td>{{row.item.SupportContractEndUtc | date}}</td>
        </tr>
      </template>
    </v-data-table>
    <!-- / Table  -->
  </div>
</template>

<script>
import EventBus from '../event-bus';

export default {
  name: 'ComputerSupportContractsFormTable',
  props: [
    'computerId',
  ],
  data() {
    return {
      hiddenStatus: 'ShowNotHidden',
      computerSupportContracts: [],
      mobileFilteredComputerSupportContracts: [],
      expanded: [],
      supportContractFields: [
        {
          text: '',
          value: 'action',
          sortable: false,
          class: 'action-column',
        },
        {
          text: 'Contract ID',
          value: 'SupportContractID',
        },
        {
          text: 'Start Date',
          value: 'SupportContractStartUtc',
        },
        {
          text: 'End Date',
          value: 'SupportContractEndUtc',
        },
      ],
    };
  },
  methods: {
    getComputerSupportContracts() {
      this.$store.dispatch('getComputerSupportContracts', {
        params: {
          HiddenStatus: this.hiddenStatus,
          ComputerID: this.computerId,
        },
      }).then((computerSupportContracts) => {
        this.computerSupportContracts = computerSupportContracts;
        if(this.computerSupportContracts) {
          this.mobileFilteredComputerSupportContracts = this.computerSupportContracts.filter(x => x.SupportContractIsDeleted === false)
          .sort((a, b) => a.SupportContractID.localeCompare(b.SupportContractID));
        }
      });
    },
  },
  created() {
    this.getComputerSupportContracts();
    EventBus.$on('getComputerSupportContracts', this.getComputerSupportContracts);
  },
  destroyed() {
    EventBus.$off('getComputerSupportContracts', this.getComputerSupportContracts);
  },
  computed : {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  }
};
</script>

<style lang="scss"></style>
